import {
  REMOVE_GROUP_COURSE,
  REMOVE_GROUP_COURSE_SUCCESS,
  REMOVE_GROUP_COURSE_CLEAN,
  REMOVE_GROUP_COURSE_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  groupCourse: {},
}

const GroupCourseRemove = (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_GROUP_COURSE:
      state = {
        ...state,
        loading: true,
      }
      break
    case REMOVE_GROUP_COURSE_SUCCESS:
      state = {
        ...state,
        groupCourse: action.payload.groupCourse,
        loading: false,
        done: true,
      }
      break
    case REMOVE_GROUP_COURSE_CLEAN:
      state = initialState
      break
    case REMOVE_GROUP_COURSE_ERROR:
      state = { ...state, error: action.payload, loading: false, done: true }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default GroupCourseRemove
